// extracted by mini-css-extract-plugin
export default {"root":"RouteSlider_root__-QXBp","slide":"RouteSlider_slide__REdQT","fullWidth":"RouteSlider_fullWidth__g9BnV","routeNav":"RouteSlider_routeNav__Lmkll"};